import React from "react";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection, Bullets } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";
import { BUSINESS } from "../data/site";

const breadcrumbs = [{ name: "Home", path: "/" }, { name: "About", path: "/about" }];

const About = () => (
  <>
    <Seo
      title="About Build Highland Homes | Custom Home Builder in Central Florida"
      description="Learn about Build Highland Homes, a custom home builder serving Central Florida. Our philosophy, craftsmanship, and build-on-your-lot approach to custom home construction."
      path="/about"
      keywords="about build highland homes, custom home builder central florida, custom home construction company"
      breadcrumbs={breadcrumbs}
    />
    <PageHero overline="About Us" title="Craftsmanship. Customization. Central Florida." subtitle="Build Highland Homes is a custom home builder dedicated to designing and building homes as individual as the families who live in them." image={IMAGES.hero} />

    <Section className="bg-[#0b0b0b]">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <Heading center={false} overline="Who We Are" title="A Custom Home Builder You Can Trust" subtitle="We are not a production or tract builder. We build custom homes on your lot, guiding you through every stage with honesty and craftsmanship." />
          <Bullets items={[
            "Custom home design and build",
            "Build-on-your-lot construction across Central Florida",
            "Premium materials and quality craftsmanship",
            "Transparent communication from start to finish",
            "Local knowledge of Central Florida building conditions",
          ]} />
        </div>
        <img src={IMAGES.newHomeBuild} alt="Build Highland Homes custom home construction" className="w-full h-[440px] object-cover border border-[#c9a24b]/20" loading="lazy" />
      </div>
    </Section>

    <Section className="bg-[#0f0f0f]">
      <Heading overline="Our Philosophy" title="Building the Backdrop for Your Life" subtitle="We believe a custom home should reflect how you live. Every decision — from the floor plan to the final finishes — is made with you and your property in mind." />
      <div className="max-w-3xl mx-auto text-center bg-[#141414] border border-[#c9a24b]/15 p-8">
        <p className="text-[#a39d90] leading-relaxed mb-2">Serving Central Florida — Brevard, Orange, Osceola, Seminole & Volusia counties.</p>
        <p className="text-[#e3c77a]">{BUSINESS.phones.join("  ·  ")}</p>
        <a href={`mailto:${BUSINESS.email}`} className="text-[#e3c77a] hover:underline">{BUSINESS.email}</a>
      </div>
    </Section>

    <CTASection />
  </>
);

export default About;
